"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var core_1 = require("@material-ui/core");
var prop_types_1 = __importDefault(require("prop-types"));
var icons_1 = require("../../icons");
var SearchHeader = function (props) {
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 1, className: "invosys-ui-SearchHeader", justifyContent: "space-between" },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            typeof props.title === "string" ? (react_1.default.createElement(core_1.Typography, { style: { textAlign: "center" }, variant: "h6", variantMapping: { h6: "div" } }, props.title)) : (props.title),
            props.subTitle &&
                (typeof props.subTitle === "string" ? (react_1.default.createElement(core_1.Typography, { style: { textAlign: "center" } }, props.subTitle)) : (props.subTitle))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 6, md: 4 },
            react_1.default.createElement(TextField_1.default, { autoFocus: true, style: { marginLeft: "12px" }, placeholder: props.placeholder, onChange: props.handleChange, InputLabelProps: { style: { marginLeft: "32px" } }, label: props.searchLabel || "", onKeyPress: function (evt) {
                    if (evt.key === "Enter") {
                        var value = evt.target.value;
                        props.searchMethod(value);
                    }
                }, fullWidth: true, value: props.searchValue, InputProps: {
                    startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(icons_1.SearchIcon, null)))
                }, inputProps: { style: { minWidth: "300px" } } })),
        react_1.default.createElement(Grid_1.default, { item: true, className: "invosys-ui-SearchHeader-actionWrapper" },
            props.actions,
            props.buttonText && (react_1.default.createElement(Button_1.default, { onClick: props.buttonPressed, variant: "contained", color: "primary" }, props.buttonText)))));
};
exports.default = SearchHeader;
SearchHeader.propTypes = {
    placeholder: prop_types_1.default.string,
    title: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    subTitle: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    buttonText: prop_types_1.default.string,
    buttonPressed: prop_types_1.default.func,
    searchValue: prop_types_1.default.string,
    heading: prop_types_1.default.string,
    handleChange: prop_types_1.default.func,
    actions: prop_types_1.default.object,
    searchLabel: prop_types_1.default.string,
    searchMethod: prop_types_1.default.func
};
